//.Net generated code

export class UserView {
    personnelNumber: number;
    name: string;
    roleId: number;
    role: string;
    phone: string;
    cityId: number;
    city: string;
    officeId: number;
    office: string;
    floorId: number;
    floor: string;
    gateId: number;
    gate: string;
    status: string;
}

export class Users {
    userId: string;
    userFirstName: string;
    userLastName: string;
    emailAlias: string;
    id: number
    
}

export class UsersPageData {
    users: UserView[];
    cities: Details[];
    roles: Details[];
    offices: Details[];
    status: string[];
    pageCount: number;
    currentPage: number;
    searchData: string;
    
}


export class UserFilter {
    city: string[];
    role: string[];
    office: string[];
    status: string[];
    searchByName: string;        
}

export class User {
    id: number;
    personnelNumber: number;
    firstName: string;
    lastName: string;
    emailId: string;
    roleId: number;
    phone: string;
    cityId: number;
    officeId: number;
    floorId: number;
    gateId: number;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
    city: City;
    floor: Floor;
    gate: Gate;
    office: Office;
    role: Role;
    
}


export class Applicationuser{

addedBy:string;
appRoleName:string;
appUserID:number; 
changedBy:string;
cityID:number;
cityName:string;
dateAdded:string;
dateChanged:Date;
emailId:string;
firstName:string;
isActive:boolean;
isApprover:boolean;
isL1:boolean;
isL2:boolean;
isRequestor:boolean;
lastName:string;
officeID:number;
officeName:string;
roleID:number;
firstLastName:string='';
practiceID:number;
practiceName:string;
}

export class Role {
    id: number;
    name: string;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
    user: User[];
    
}

export class Office {
    officeID: number;
    officeName: string;
    postWorkingHour: string;
    cityId: number;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
    city: City;
    employeeCheckOut: EmployeeCheckOut[];
    gate: Gate[];
    user: User[];
    
}

export class Details {
    id: number;
    name: string;
    
}

export class Gate {
    id: number;
    name: string;
    officeId: number;
    floorId: number;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
    floor: Floor;
    office: Office;
    employeeCheckOut: EmployeeCheckOut[];
    user: User[];
    
}

export class Floor {
    id: number;
    name: string;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
    employeeCheckOut: EmployeeCheckOut[];
    gate: Gate[];
    user: User[];
    
}

export class EmployeeCheckOut {
    id: number;
    personnelNumber: number;
    cardNumber: number;
    firstName: string;
    lastName: string;
    emailId: string;
    cityId: number;
    officeId: number;
    floorId: number;
    gateId: number;
    shiftSupervisor: string;
    exitTime: Date;
    transportModeId: number;
    vehicleDetailId: number;
    transportComments: string;
    sourceType: string;
    dateAdded: Date;
    city: City;
    floor: Floor;
    gate: Gate;
    office: Office;
    transportMode: TransportMode;
    vehicleDetail: VehicleDetail;
    
}

export class City {
    cityID: number;
    cityName: string;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
    employeeCheckOut: EmployeeCheckOut[];
    office: Office[];
    user: User[];
    
}


export class TransportMode {
    id: number;
    typeOfMode: string;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    isActive: boolean;
   // office: Office[];
    user: User[];   
    employeeCheckOut: EmployeeCheckOut[];
    
}

export class VehicleDetail {
    id: number;
    vehicleprovider: string;
    vehicleType: string;
    rideType: string;
    vehicleRegNumber: string;
    dateAdded: Date;
    addedBy: string;
    dateChanged: Date;
    changedBy: string;
    employeeCheckOut: EmployeeCheckOut[];
}